// extracted by mini-css-extract-plugin
module.exports = {"container":"RecordingIndicator_container__2Digd","circle":"RecordingIndicator_circle__1xeO3","text":"RecordingIndicator_text__3YU5m"};